export default "__VITE_ASSET__glXnO8kU__"